import { CommonPlayerLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/player/logic/common-player-logic';

export class CommonPlayLogicWithTextEditor extends CommonPlayerLogic {
    public editorInitialCursor = 'auto';
}
